import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromOpportunities from '@features/opportunities/shared/reducers/opportunities.reducer';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { Observable } from 'rxjs';
import { LoadingState } from '@shared/types/loading-state';
import { Opportunity } from '@shared/models/opportunity';
import { OpportunityFilters } from '@shared/models/opportunity-filters';
import { loadOpportunities } from '../actions/load-opportunities.actions';
import { loadOpportunity } from '../shared/actions/load-opportunity.actions';
import { updateOpportunity } from '../actions/update-opportunity.actions';
import { setOpportunityFilters } from '../shared/actions/set-opportunity-filters.actions';

@Injectable({
  providedIn: 'root',
})
export class OpportunitiesService {
  constructor(private store: Store) {}

  loadOpportunity(opportunityId: number) {
    this.store.dispatch(loadOpportunity({ opportunityId }));
  }

  loadOpportunities(filters: OpportunityFilters, paginationState: PaginationState, sorting: Sorting) {
    this.store.dispatch(loadOpportunities({ filters, paginationState, sorting }));
  }

  updateOpportunity(opportunity: Partial<Opportunity>) {
    this.store.dispatch(updateOpportunity({ opportunity }));
  }

  setOpportunityFilters(filters: OpportunityFilters) {
    this.store.dispatch(setOpportunityFilters({ filters }));
  }

  getOpportunitiesLoadingText(): Observable<string | undefined> {
    return this.store.select(fromOpportunities.selectOpportunitiesLoadingText);
  }

  getOpportunitiesLoadingState(): Observable<LoadingState> {
    return this.store.select(fromOpportunities.selectOpportunitiesLoadingState);
  }

  getOpportunitiesPaginationState(): Observable<PaginationState> {
    return this.store.select(fromOpportunities.selectOpportunitiesPaginationState);
  }

  getOpportunities(): Observable<Opportunity[]> {
    return this.store.select(fromOpportunities.selectAllOpportunities);
  }

  getOpportunityById(opportunityId: number): Observable<Opportunity | undefined> {
    return this.store.select(fromOpportunities.selectOpportunityById(opportunityId));
  }

  getOpportunityFilters(): Observable<OpportunityFilters | undefined> {
    return this.store.select(fromOpportunities.selectOpportunityFilters);
  }
}
